import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import Section from "../../../models/API/responseModels/sectionsDataResponse.model";
import axiosInstance from "../../../api";
import { useOktaAuth } from "@okta/okta-react";

function useSections(): UseQueryResult<AxiosResponse<Section[]>, any> {
 const oktaAuth = useOktaAuth();

 return useQuery({
  queryKey: ["sections"],
  queryFn: () =>
   axiosInstance
    .get(`v1/section`, {
     headers: {
      Authorization: `Bearer ${oktaAuth?.authState?.accessToken?.accessToken}`,
     },
    })
    .then((res) => res.data),
  enabled: !!oktaAuth?.authState?.accessToken?.accessToken,
 });
}

export default useSections;
